/** Dialog wrapper for editing an existing task. */

import { CheckCircle } from 'lucide-react'
import { toast } from 'sonner'

import type { TaskResponse } from '@snootsvet/shared'

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/frontend/components/ui/dialog'
import { EditTaskForm } from '@/frontend/features/tasks/forms/edit-task.form'

interface EditTaskDialogProps {
  task: TaskResponse
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function EditTaskDialog({ task, open, onOpenChange }: EditTaskDialogProps) {
  // Outside-click dismissal is disabled to avoid losing entered task details.
  return (
    <Dialog open={open} onOpenChange={onOpenChange} disablePointerDismissal>
      <DialogContent className="max-h-[85vh] overflow-y-auto overflow-x-hidden">
        <DialogHeader>
          <DialogTitle>Edit Task</DialogTitle>
        </DialogHeader>
        <EditTaskForm
          task={task}
          onSuccess={() => {
            toast('Task updated', { icon: <CheckCircle className="size-4 text-success-fg" /> })
            onOpenChange(false)
          }}
          onCancel={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  )
}
